import {ApplicationRef, Component, Input, OnInit} from '@angular/core';
import {
  VenueDatabaseAnalyticsModel,
  VenueGridConfiguration, VenueListFilterEnumsModel, VenueLocationListRequestModel,
  VenueRequestModel
} from './venue-database.model';
import {VenueDatabaseService} from './venue-database.service';
import {EnumModel} from 'app/shared/objects/EnumModel';
import {StatisticsGroupModel} from '../../shared/objects/statistics-group.model';
import {GroupDatabaseService} from '../group-database/group-database.service';
import {TokenManagerService} from '../../shared/services/token-login.service';

@Component({
  selector: 'app-venue-database',
  templateUrl: './venue-database.component.html',
  providers: [VenueDatabaseService, GroupDatabaseService],
  styleUrls: ['./venue-database.component.less']
})
export class VenueDatabaseComponent implements OnInit {
  @Input() managerAdmin: boolean;

  selectedVenueId: number;
  selectedSearchString = '';
  showVenue = false;
  showMap = false;
  mapRequest = new VenueLocationListRequestModel();
  isUserAdmin: boolean;

  searchEnums: VenueListFilterEnumsModel;
  selectedStatus: EnumModel;
  selectedType: EnumModel;
  selectedLocation: EnumModel;
  newVenueFromGroupId: number;
  searchValue: string;
  map: any;

  venueGridConfiguration: VenueGridConfiguration;
  venueGridRequest: VenueRequestModel;
  statisticsGroupModel: StatisticsGroupModel[];
  venueDatabaseAnalyticsModel = new VenueDatabaseAnalyticsModel();

  showGroup = false;
  selectedGroupId = null;

  constructor(private venueDatabaseService: VenueDatabaseService, private appRef: ApplicationRef) {
  }

  ngOnInit() {
    this.isUserAdmin = TokenManagerService.isAdmin() || this.managerAdmin;
    
    this.venueDatabaseService.getVenueDatabaseAnalytics(this.venueDatabaseAnalyticsModel)
      .subscribe(
        (response) => {
          this.statisticsGroupModel = response;
        },
        (error) => console.log(error)
      );

    this.venueDatabaseService.getFilterEnums()
      .subscribe((response: VenueListFilterEnumsModel) => {
        this.searchEnums = response;


        this.selectedStatus = this.searchEnums.status[0];
        this.selectedType = this.searchEnums.venueType[0];
        this.selectedLocation = this.searchEnums.location[0];

        this.venueGridConfiguration = new VenueGridConfiguration();
        this.venueGridConfiguration.service = this.venueDatabaseService;
        this.venueGridRequest = new VenueRequestModel();
        this.venueGridRequest.status = this.selectedStatus.id;
        this.venueGridRequest.type = this.selectedType.id;
        this.venueGridRequest.location = this.selectedLocation.id;
        this.venueGridConfiguration.onRowClick.subscribe( (e) => {
          this.show(e);
        });
      });

  }

  toggleMapView() {
    this.showMap = !this.showMap;
  }


  showMapView() {
    this.showMap = true;
    this.populateMap();
  }
  populateMap() {
    const bounds = new google.maps.LatLngBounds();
    let markers;
    this.venueDatabaseService.getAllVenuesLocations(this.mapRequest).subscribe(
      (response) => {
        console.log(response);
        markers = response;
        this.map = new google.maps.Map(document.getElementById('main-map'), {
          center: {lat: 51.5074, lng: 0.1278},
          zoom: 13,
          disableDefaultUI: true
        });

        for (let marker of markers) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(marker.latitude, marker.longitude),
            map: this.map,
            id: marker.id
          });
          bounds.extend(marker.getPosition());

          marker.addListener('click', () => {
            this.show(marker.id);
          });
        }
        this.map.fitBounds(bounds);
      });
  }

  show(e) {
    if (typeof e === 'number' || e === null) {
      this.selectedVenueId = e;
    } else {
      this.selectedVenueId = e.data.id;
    }
    this.showVenue = true;
  }

  typeChanged(item: EnumModel) {
    this.venueDatabaseAnalyticsModel.type = this.selectedType.id;
    this.updateStatistic(this.venueDatabaseAnalyticsModel);
    this.venueGridRequest.type = this.selectedType.id;
    this.mapRequest.type = this.selectedType.id;
    if (this.showMap) {
      this.populateMap();
    } else {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }
  }

  statusChanged() {
    this.venueDatabaseAnalyticsModel.status = this.selectedStatus.id;
    this.updateStatistic(this.venueDatabaseAnalyticsModel);
    this.venueGridRequest.status = this.selectedStatus.id;
    this.mapRequest.status = this.selectedStatus.id;
    if (this.showMap) {
      this.populateMap();
    } else {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }  }

  locationChanged() {
    this.venueDatabaseAnalyticsModel.location = this.selectedLocation.id;
    this.updateStatistic(this.venueDatabaseAnalyticsModel);
    this.venueGridRequest.location =  this.selectedLocation.id;
    this.mapRequest.location = this.selectedLocation.id;
    if (this.showMap) {
      this.populateMap();
    } else {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }  }

  search(value) {
    this.venueGridConfiguration.customSearch[0].value = value;
    this.mapRequest.searchString = value;
    if (this.showMap) {
      this.populateMap();
    } else {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }  }

  updateStatistic (venueDatabaseAnalyticsModel: VenueDatabaseAnalyticsModel) {
    this.venueDatabaseService.getVenueDatabaseAnalytics(venueDatabaseAnalyticsModel)
      .subscribe(
        (response) => {
          this.statisticsGroupModel = response;
        },
        (error) => console.log(error)
      );
  }

  venueChanged(refresh) {
    this.showVenue = false;
    this.showGroup = false;
    if (refresh) {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }
  }

  switchShownVenue(venueId) {
    this.showVenue = false;
    this.showGroup = false;
    this.appRef.tick();
    this.show(venueId);
  }

  newVenue(groupId) {
    this.showVenue = false;
    this.showGroup = false;

    this.newVenueFromGroupId = groupId;
    this.appRef.tick();
    this.show(null);
  }
  closeCreateGroup(refresh) {
    this.showGroup = false;
    if (refresh === true) {
      this.venueGridConfiguration.dataGrid.instance.getDataSource().reload();
    }
  }
  showGroupById(id) {
    this.showVenue = false;
    this.selectedGroupId = id;
    this.showGroup = true;
  }
  exportToExcel() {
    this.venueGridConfiguration.dataGrid.instance.exportToExcel(false);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-database/venue-database.component.ts